import { db } from "~/utils/db";
import { defineStore } from "pinia";
import { useDefaultStore } from "~/stores/default";
import useUtil from "~/composables/useUtil";
import useSupabase from "~/composables/useSupabase";
import useData from "~/composables/useData";
import { useRoute, navigateTo } from "#app";

export const useFunctionsheetStore = defineStore("functionsheet", {
    state: () => ({
        initialized: {
            dayview: false,
            weekview: false,
            monthview: false,
        },

        fetchId: 0,
        page: "", // day, week, month

        // orderData -> moved to default store!
        updatedOrderDataProcessed: false,
        // productData -> moved to default store!
        supabaseData: null,

        date: "",
        week: "",
        month: "",
        upcomingDays: [], // holds days for dayview-shortcuts
        days: [],
        kws: [],
        kwDays: {},

        // todo dynamic per day ?
        // slots: [
        //     "08:00 - 09:00",
        //     "09:00 - 10:00",
        //     "10:00 - 11:00",
        //     "11:00 - 12:00",
        //     "12:00 - 13:00",
        //     "13:00 - 14:00",
        //     "14:00 - 15:00",
        //     "15:00 - 16:00",
        //     "16:00 - 17:00",
        //     "17:00 - 18:00",
        //     "18:00 - 19:00",
        //     "19:00 - 20:00",
        //     "20:00 - 21:00",
        //     "21:00 - 22:00",
        // ],
        slots: [
            // "keine Angabe", // should not be the case
            "06:00 - 08:00",
            "08:00 - 10:00",
            "10:00 - 12:00",
            "12:00 - 14:00",
            "14:00 - 18:00",
            "18:00 - 22:00",
            "22:00 - 24:00",
        ],
        focusedColumn: 0,
        expandedColumn: 0,
        expandedOrder: 0,
        focusedOrderObject: null,
        focusedDay: 0,

        groupByFinishTime: true,

        tagFilter: "",

        // needs to be synced with PHP function getProductJS( $product ) if anything else than "fs-"
        productCategories: [
            {
                slug: "fs-breakfast",
                label: "Breakfast",
            },
            {
                slug: "fs-mezze-hot",
                label: "Mezze Hot",
            },
            {
                slug: "fs-mezze-fresh",
                label: "Mezze Fresh",
            },
            {
                slug: "fs-salat",
                label: "Salat",
            },
            {
                slug: "fs-fingerfood-fast",
                label: "Fingerfood Fast",
            },
            {
                slug: "fs-fingerfood-handmade",
                label: "Fingerfood Handmade",
            },
            {
                slug: "fs-fingerfood-selection",
                label: "Fingerfood Selections",
            },
            {
                slug: "hot",
                label: "Hot Dishes",
            },
            {
                slug: "fs-dessert",
                label: "Dessert",
            },
            {
                slug: "fs-single",
                label: "Singles",
            },
            {
                slug: "service",
                label: "Service",
            },
            {
                slug: "uncategorized",
                label: "No Category",
            },
            {
                slug: "dishes",
                label: "Dishes & Equipment",
            },
            {
                slug: "fs-dishes-bio",
                label: "Dishes (bio)",
            },
            {
                slug: "drinks",
                label: "Drinks",
            },
            {
                slug: "foodbike",
                label: "Foodbike",
            },
        ],

        cells: {}, // []
        cellsInitialized: false,

        stammkundeModal: {
            shown: false,
            order: null,
            top: 0,
            left: 0,
        },

        labelPrinterUrl: "https://rpi-printer-server.local",
        labelPrintModal: {
            shown: false,
            isSending: false,
            amount: 1,
            productName: "",
            top: 0,
            left: 0,
        },

        boxModal: {
            shown: false,
            isSending: false,
            selectedBoxes: [],
            boxesAmount: 24,
            confirmationModalShown: false,
        },

        productImageModal: {
            shown: false,
            productName: "",
            productImageSrc: "",
            top: 0,
            left: 0,
        },

        workers: [],
        selectedWorkerId: "",
        showPreparationModal: false,

        // productComponents: {}, // not in use atp
        // componentPosts: {},

        wcInterval: null,
    }),
    getters: {
        dayInfos(state) {
            const store = useDefaultStore();
            const { pushIfNotIncludes, accumulateMenus } = useUtil();

            /*****
             * - object for all slots of the day
             * - within, object for relevant products of that slot
             * - id as key
             * - value is object: {
             *      fs_category: ,
             *      quantity: ,
             *      orders: [ids],
             *      size: ,
             * }
             */

            if (!store.orderData?.[store.curShop.url] || !store.productData) {
                return {
                    productDaySlotTotals: {},
                    dayProducts: {},
                    productDayTotals: {},
                };
            }

            const productDaySlotTotals = {};
            const dayProducts = {};
            const productDayTotals = {};

            const theDays = state.days.slice(0);
            if (!theDays.length) theDays.push(state.date);

            for (const date of theDays) {
                if (!store.orderData[store.curShop.url][date]) continue;
                const productTodaySlotTotals = {};
                /*****
                 * structure
                 * url.date: {
                 *      name: { // menu
                 *          size: {
                 *              orders,
                 *              fs_category,
                 *              quantity,
                 *              ids,
                 *          },
                 *          size: {}
                 *      }
                 * }
                 */

                const todayProducts = {
                    names: [],
                    ids: [],
                };

                for (const order of store.orderData[store.curShop.url][date]) {
                    // filter out orders, if a tag is selected
                    if (state.tagFilter) {
                        if (!order.fsTags.includes(state.tagFilter)) continue;
                    }
                    for (const menu of order.menus) {
                        // get associated product with all info
                        const product = store.productData[menu.id];
                        if (!product) {
                            console.error(
                                "this product is too old and therefore unknown - it cant be displayed",
                            );
                            console.log("associated order:", order);
                            // continue;
                        }

                        todayProducts.names.push(menu.name);
                        todayProducts.ids.push(menu.id);

                        const slot = order.fsSlot;

                        // if the slot is not yet populated, we create an entry
                        if (!productTodaySlotTotals[slot])
                            productTodaySlotTotals[slot] = {};

                        // if this menu is not yet listed for today, create an entry
                        // might be an idea to make name the key and add id to the object, AFTER MIRROR! check for duplicate names
                        if (!productTodaySlotTotals[slot][menu.name])
                            productTodaySlotTotals[slot][menu.name] = {};

                        if (!productTodaySlotTotals[slot][menu.name][menu.size])
                            productTodaySlotTotals[slot][menu.name][menu.size] =
                                {
                                    fs_category:
                                        product?.fs_category || "uncategorized",
                                    quantity: 0,
                                    orders: [],
                                    ids: [],
                                };

                        // add the corresponding values to the object, whether it existed before or not
                        pushIfNotIncludes(
                            productTodaySlotTotals[slot][menu.name][menu.size]
                                .orders,
                            order.id,
                        ); // might want order number?
                        pushIfNotIncludes(
                            productTodaySlotTotals[slot][menu.name][menu.size]
                                .ids,
                            menu.id,
                        ); // might want order number?
                        productTodaySlotTotals[slot][menu.name][
                            menu.size
                        ].quantity += menu.qty;
                    }
                }

                // make unique
                todayProducts.names = [...new Set(todayProducts.names)];
                todayProducts.ids = [...new Set(todayProducts.ids)];

                // accumulate for whole day (for dayview and weekview!)
                // Step 1: Flatten the array of totals per slot
                const flattenedOrders = Object.values(
                    productTodaySlotTotals,
                ).flat();

                // Step 2: Combine the menus by deep-merging their size configurations for whole day
                const productTodayTotals = accumulateMenus(flattenedOrders);

                productDaySlotTotals[date] = productTodaySlotTotals;
                dayProducts[date] = todayProducts;
                productDayTotals[date] = productTodayTotals;
            }

            return {
                productSlotTotals: productDaySlotTotals,
                products: dayProducts,
                productTotals: productDayTotals,
            };
        },
        weekInfos(state): { productTotals: object } {
            // console.time('weekInfos')
            const { accumulateMenus } = useUtil();

            const productWeekTotals = {};

            // make sure to only accumulate the wanted week...
            const thisWeek = Object.assign({}, this.dayInfos.productTotals);
            for (const key of Object.keys(thisWeek)) {
                if (!state.days.includes(key)) delete thisWeek[key];
            }

            // init week totals
            const flattenedDays = Object.values(thisWeek).flat();
            const combinedWeekMenus = accumulateMenus(flattenedDays);
            productWeekTotals[state.week] = combinedWeekMenus;

            // console.timeEnd('weekInfos')

            return { productTotals: productWeekTotals };
        },
        monthInfos(state): {
            productTotals: object;
            productWeekTotals: object;
        } {
            // console.time('monthInfos')
            const { accumulateMenus } = useUtil();

            const productWeekTotals = {};

            const allDays = Object.assign({}, this.dayInfos.productTotals);

            for (const kw in this.kwDays) {
                productWeekTotals[kw] = [];
                for (const day of this.kwDays[kw]) {
                    productWeekTotals[kw].push(allDays[day]);
                }
                const flattenedKw = Object.values(productWeekTotals[kw]).flat();
                const combinedKwMenus = accumulateMenus(flattenedKw);
                productWeekTotals[kw] = combinedKwMenus;
            }

            const flattenedMonth = Object.values(productWeekTotals).flat();
            const combinedMonthMenus = accumulateMenus(flattenedMonth);
            const productMonthTotals = combinedMonthMenus;

            // console.timeEnd('monthInfos')

            return {
                productTotals: productMonthTotals,
                productWeekTotals: productWeekTotals,
            };
        },

        // ============================================
        // Preparation State Getters (derived from supabaseData)
        // These MUST be getters (not actions) for Vue reactivity to work!
        // ============================================

        // Index: O(1) lookup of orders by dailyId - avoids O(n) find() calls
        ordersByDailyId(state): Record<string, any> {
            const store = useDefaultStore();
            const orders = store.orderData?.[store.curShop.url]?.[state.date] || [];
            const map: Record<string, any> = {};
            for (const order of orders) {
                map[String(order.dailyId)] = order;
            }
            return map;
        },

        // Get active (not done, not aborted) processes for current date
        activeProcesses(state): any[] {
            return (state.supabaseData || []).filter(
                (p: any) => !p.done && !p.aborted && p.date === state.date
            );
        },

        // Get finished processes for current date
        finishedProcesses(state): any[] {
            return (state.supabaseData || []).filter(
                (p: any) => p.done && !p.aborted && p.date === state.date
            );
        },

        // Build a map: { "slot/product": { dailyId: workerId } } for preparing
        // Uses ordersByDailyId for O(1) lookups instead of O(n) find()
        preparingMap(): Record<string, Record<string, string>> {
            const orderIndex = this.ordersByDailyId;
            const map: Record<string, Record<string, string>> = {};
            for (const process of this.activeProcesses) {
                for (const [dailyId, products] of Object.entries(
                    process.daily_id_products || {}
                )) {
                    const order = orderIndex[String(dailyId)];
                    if (!order) continue;
                    for (const productName of Object.keys(products as Record<string, unknown>)) {
                        const cellKey = `${order.fsSlot}/${productName}`;
                        if (!map[cellKey]) map[cellKey] = {};
                        map[cellKey][dailyId] = process.worker_id;
                    }
                }
            }
            return map;
        },

        // Build a map: { "slot/product": [dailyId, ...] } for prepared
        // Uses ordersByDailyId for O(1) lookups instead of O(n) find()
        preparedMap(): Record<string, string[]> {
            const orderIndex = this.ordersByDailyId;
            const map: Record<string, string[]> = {};
            for (const process of this.finishedProcesses) {
                for (const [dailyId, products] of Object.entries(
                    process.daily_id_products || {}
                )) {
                    const order = orderIndex[String(dailyId)];
                    if (!order) continue;
                    for (const productName of Object.keys(products as Record<string, unknown>)) {
                        const cellKey = `${order.fsSlot}/${productName}`;
                        if (!map[cellKey]) map[cellKey] = [];
                        if (!map[cellKey].includes(dailyId)) map[cellKey].push(dailyId);
                    }
                }
            }
            return map;
        },

        // Pre-computed lookup: is this (dailyId, productName) prepared?
        // Returns { "dailyId/productName": true } for O(1) template lookups
        preparedLookup(): Record<string, boolean> {
            const lookup: Record<string, boolean> = {};
            for (const [cellKey, dailyIds] of Object.entries(this.preparedMap)) {
                for (const dailyId of dailyIds) {
                    // cellKey is "slot/product", we want "dailyId/product"
                    const product = cellKey.split('/')[1];
                    lookup[`${dailyId}/${product}`] = true;
                }
            }
            return lookup;
        },

        // Pre-computed lookup: is this (dailyId, productName) preparing?
        // Returns { "dailyId/productName": workerId } for O(1) template lookups
        preparingLookup(): Record<string, string> {
            const lookup: Record<string, string> = {};
            for (const [cellKey, dailyIdWorkers] of Object.entries(this.preparingMap)) {
                for (const [dailyId, workerId] of Object.entries(dailyIdWorkers)) {
                    const product = cellKey.split('/')[1];
                    lookup[`${dailyId}/${product}`] = workerId;
                }
            }
            return lookup;
        },
    },
    actions: {
        // Legacy method wrappers - use getters directly for reactivity
        getActiveProcesses() {
            return this.activeProcesses;
        },
        getFinishedProcesses() {
            return this.finishedProcesses;
        },
        getPreparingMap() {
            return this.preparingMap;
        },
        getPreparedMap() {
            return this.preparedMap;
        },

        // Check if worker is preparing anything
        isWorkerPreparing(workerId: string) {
            return this.activeProcesses.some((p: any) => p.worker_id === workerId);
        },

        // Get all products a worker is preparing (for display)
        getWorkerPreparingProducts(workerId: string) {
            const products: string[] = [];
            for (const process of this.activeProcesses) {
                if (process.worker_id !== workerId) continue;
                for (const [, prods] of Object.entries(process.daily_id_products || {})) {
                    for (const productName of Object.keys(prods as Record<string, unknown>)) {
                        if (!products.includes(productName)) products.push(productName);
                    }
                }
            }
            return products;
        },

        // Get process for a specific worker (for stopping preparation)
        getWorkerProcess(workerId: string) {
            return this.activeProcesses.find((p: any) => p.worker_id === workerId);
        },

        // Unified partial states getter - works for both normal and groupByFinishTime modes
        // Takes orders array (already filtered to the relevant column) and productName
        // Uses O(1) lookup getters for performance
        getCellPartialStates(orders: any[], productName: string) {
            if (!orders || orders.length === 0) {
                return {
                    clicked: false,
                    preparing: false,
                    prepared: false,
                    packed: false,
                    partiallyPrepared: false,
                    partiallyPreparing: false,
                    mixedProgress: false,
                    allPreparing: false,
                    allPrepared: false,
                };
            }

            // Use O(1) lookup getters instead of iterating maps
            const preparingLookup = this.preparingLookup;
            const preparedLookup = this.preparedLookup;

            // Check preparing states - O(1) lookup per order
            const somePreparing = orders.some((order: any) => {
                return !!preparingLookup[`${order.dailyId}/${productName}`];
            });
            const allPreparing = orders.every((order: any) => {
                return !!preparingLookup[`${order.dailyId}/${productName}`];
            });

            // Check prepared states - O(1) lookup per order
            const somePrepared = orders.some((order: any) => {
                return !!preparedLookup[`${order.dailyId}/${productName}`];
            });
            const allPrepared = orders.every((order: any) => {
                const packedList = this.cells[order.fsSlot]?.[productName]?.packed || [];
                return !!preparedLookup[`${order.dailyId}/${productName}`] || packedList.includes(order.orderNumber);
            });

            // Check clicked state
            const isClicked = orders.some((order: any) => {
                const cell = this.cells[order.fsSlot]?.[productName];
                return cell?.clickedDailyIds?.includes(order.dailyId);
            });

            // Check packed state
            const totalPackedCount = orders.filter((order: any) => {
                const packedList = this.cells[order.fsSlot]?.[productName]?.packed || [];
                return packedList.includes(order.orderNumber);
            }).length;
            const isPacked = orders.length > 0 && totalPackedCount === orders.length;

            // Compute final states
            const isPreparing = !isPacked && !allPrepared && allPreparing;
            const isPrepared = !isPacked && allPrepared;

            return {
                clicked: isClicked,
                preparing: isPreparing,
                prepared: isPrepared,
                packed: isPacked,
                partiallyPrepared: somePrepared && !allPrepared && !somePreparing,
                partiallyPreparing: somePreparing && !allPreparing && !allPrepared && !somePrepared,
                mixedProgress: somePrepared && !allPrepared && somePreparing,
                allPreparing: allPreparing && !allPrepared,
                allPrepared,
            };
        },

        async initFunctionsheetDayview() {
            const store = useDefaultStore();
            console.log("initing dayview");
            console.time("fsInit");

            const {
                initSupabase,
                supabaseFetch,
                supabaseRealtimeInitProcesses,
            } = useSupabase();
            const { orchestrateOrderFetch } = useData();

            // reset raw data so it fetches again if we're coming from weekview
            store.rawOrderData = null;
            this.updatedOrderDataProcessed = false;
            this.cellsInitialized = false;

            this.initWorkers(); // async, but has no dependencies - call early!
            this.initDateWeekMonth();

            // init day shortcuts for dayview
            const dateObj = new Date();
            const amountOfDays = 14;
            for (let i = 0; i < amountOfDays; i++) {
                const newDateObj = new Date(dateObj);
                const weekday = newDateObj.toLocaleDateString("de-DE", {
                    weekday: "short",
                });
                const date = newDateObj.toLocaleDateString("de-DE", {
                    day: "2-digit",
                    month: "2-digit",
                });
                const iso = newDateObj.toLocaleDateString("sv");
                this.upcomingDays[i] = [weekday, date, iso];
                dateObj.setDate(dateObj.getDate() + 1);
            }
            this.upcomingDays[0][0] = "Heute";
            this.upcomingDays[1][0] = "Morgen";

            await initSupabase(); // TODO: not clean, to have to await here - consider moving it to useData OR moving essential call out of initSupabase...
            await Promise.all([
                orchestrateOrderFetch({
                    getDates: () => [this.date],
                    getFetchId: () => this.fetchId,
                    setFetchId: (id: number) => (this.fetchId = id),
                    setProcessing: (isProcessing: boolean) =>
                        (store.processing = isProcessing),
                    setLoading: (isLoading: boolean) =>
                        (store.loading = isLoading),
                }),
                supabaseFetch(),
            ]);

            this.initCells();

            await this.checkForCancellation();
            if (!this.wcInterval) {
                this.wcRealtimeInit();
            }

            // Initialize improved realtime system
            this.initRealtimeSystem();

            this.checkForStammkunden();

            this.initialized.dayview = true;
            console.timeEnd("fsInit");
        },
        async initFunctionsheetWeekview() {
            console.log("initing weekview");
            console.time("fsInit");

            const store = useDefaultStore();

            const { orchestrateOrderFetch } = useData();
            const { getWeekDates } = useUtil();

            if (!store.auth.jwts[store.curShop.url]) {
                return;
            }

            store.rawOrderData = null;
            this.updatedOrderDataProcessed = false;
            store.rawProductData = null;

            this.initDateWeekMonth();
            this.days = [];

            const weekDates = getWeekDates(this.week);
            let iterDate = new Date(weekDates.startDate);
            do {
                this.days.push(iterDate.toLocaleDateString("sv"));
                iterDate = new Date(iterDate.setDate(iterDate.getDate() + 1));
            } while (iterDate.toLocaleDateString("sv") != weekDates.endDate);
            this.days.push(weekDates.endDate);

            await orchestrateOrderFetch({
                getDates: () => this.days,
                getFetchId: () => this.fetchId,
                setFetchId: (id: number) => (this.fetchId = id),
                setProcessing: (isProcessing: boolean) =>
                    (store.processing = isProcessing),
                setLoading: (isLoading: boolean) => (store.loading = isLoading),
            });

            await this.checkForCancellation();
            if (!this.wcInterval) {
                this.wcRealtimeInit();
            }
            // this.checkForStammkunden(); // don't fetch for weekview

            this.initialized.weekview = true;
            console.timeEnd("fsInit");
        },
        async initFunctionsheetMonthview() {
            console.log("initing monthview");
            console.time("fsInit");

            const store = useDefaultStore();

            const { orchestrateOrderFetch } = useData();
            const { getISOWeek, getWeekDates } = useUtil();

            if (!store.auth.jwts[store.curShop.url]) {
                return;
            }

            store.rawOrderData = null;
            this.updatedOrderDataProcessed = false;
            store.rawProductData = null;

            this.initDateWeekMonth();
            this.days = [];
            this.kws = [];
            this.kwDays = {};

            const [year, month] = this.month.split("-").map(Number);
            const date = new Date(year, month - 1, 1);
            const weeks = new Set();

            while (date.getMonth() === month - 1) {
                const week = getISOWeek(date);
                weeks.add(
                    `${(date as any).getWeekYear()}-${String(week).padStart(2, "0")}`,
                );
                date.setDate(date.getDate() + 1);
            }

            this.kws = Array.from(weeks);

            for (const kw of this.kws) {
                this.kwDays[kw] = [];
                const dates = getWeekDates(kw);
                let iterDate = new Date(dates.startDate);
                do {
                    const iterISO = iterDate.toLocaleDateString("sv");
                    this.kwDays[kw].push(iterISO);
                    this.days.push(iterISO);
                    iterDate = new Date(
                        iterDate.setDate(iterDate.getDate() + 1),
                    );
                } while (iterDate.toLocaleDateString("sv") != dates.endDate);
                this.days.push(dates.endDate);
                this.kwDays[kw].push(dates.endDate);
            }

            await orchestrateOrderFetch({
                getDates: () => this.days,
                getFetchId: () => this.fetchId,
                setFetchId: (id: number) => (this.fetchId = id),
                setProcessing: (isProcessing: boolean) =>
                    (store.processing = isProcessing),
                setLoading: (isLoading: boolean) => (store.loading = isLoading),
            });

            await this.checkForCancellation();
            if (!this.wcInterval) {
                this.wcRealtimeInit();
            }

            this.initialized.monthview = true;
            console.timeEnd("fsInit");
        },
        logSelf() {
            console.log(this.$state);
            const store = useDefaultStore();
            console.log(store.$state);
        },

        // setup date and week
        initDateWeekMonth() {
            console.log("initDateWeekMonth called");
            const previousDate = this.date; // Track previous date

            const route = useRoute();
            const { getISOWeek } = useUtil();

            // date format: YYYY-MM-DD
            // week format: YYYY-KW
            // month format: YYYY-MM
            if (route.params.date) {
                this.date = Array.isArray(route.params.date)
                    ? route.params.date[0]
                    : route.params.date;

                // default to week of selected date
                const dateObj = new Date(this.date);
                const weekNumber = getISOWeek(dateObj);
                this.week =
                    (dateObj as any).getWeekYear() +
                    "-" +
                    weekNumber.toString().padStart(2, "0");

                // set month according to month of selected date
                this.month =
                    dateObj.getFullYear() +
                    "-" +
                    (dateObj.getMonth() + 1).toString().padStart(2, "0");
            } else if (route.params.kw) {
                this.week = Array.isArray(route.params.kw)
                    ? route.params.kw[0]
                    : route.params.kw;

                // set date to monday of the week
                // if the week is the current week, set date to today
                const today = new Date();
                const [year, week] = this.week.split("-").map(Number);
                if (
                    year == (today as any).getWeekYear() &&
                    week == getISOWeek(today)
                ) {
                    this.date = new Date().toLocaleDateString("sv");
                } else {
                    const firstDayOfYear = new Date(year, 0, 1);
                    const dayOfWeek = firstDayOfYear.getDay();

                    // Calculate the offset to the first ISO week Monday
                    const offsetToMonday =
                        dayOfWeek <= 4 ? dayOfWeek - 1 : dayOfWeek - 8;

                    // Calculate the Monday of the given week
                    const daysOffset = (week - 1) * 7 - offsetToMonday;
                    const monday = new Date(
                        firstDayOfYear.setDate(
                            firstDayOfYear.getDate() + daysOffset,
                        ),
                    );

                    this.date = monday.toLocaleDateString("sv");
                }

                // set month according to month of selected date
                const dateObj = new Date(this.date);
                this.month =
                    dateObj.getFullYear() +
                    "-" +
                    (dateObj.getMonth() + 1).toString().padStart(2, "0");
            } else {
                this.month = Array.isArray(route.params.month)
                    ? route.params.month[0]
                    : route.params.month;

                const [year, month] = this.month.split("-").map(Number);
                // date: if this.month is curMonth, select today
                //      otherwise select the first of the month
                // week: if this.month is curMonth, select current kw
                //      otherwise select the first (full?) kw of the month
                const today = new Date();
                if (
                    year == today.getFullYear() &&
                    month == today.getMonth() + 1
                ) {
                    this.date = today.toLocaleDateString("sv");
                    this.week =
                        (today as any).getWeekYear() + "-" + String(getISOWeek(today)).padStart(2, "0");
                } else {
                    const firstDayOfMonth = new Date(year, month - 1, 1);
                    this.date = firstDayOfMonth.toLocaleDateString("sv");
                    this.week =
                        (firstDayOfMonth as any).getWeekYear() +
                        "-" +
                        String(getISOWeek(firstDayOfMonth)).padStart(2, "0");
                }
            }

            // Log date changes for debugging
            if (previousDate && previousDate !== this.date) {
                console.log(
                    "[DEBUG] Date changed from",
                    previousDate,
                    "to",
                    this.date,
                );
                console.log(
                    "[DEBUG] Cleaning up and reinitializing realtime subscription for new date",
                );

                // Clean up existing realtime subscriptions when date changes
                this.cleanupRealtimeSubscriptions();

                // Reinitialize the realtime system for the new date
                setTimeout(() => {
                    this.initRealtimeSystem();
                }, 100);
            }
        },

        // setup productData (fetchProducts, processProductData) -> moved to default store!

        // setup orderData (fetchOrders, processOrderData, createOrderEntry, setupProductQuantitiesOfOrder) -> moved to defaultStore!

        async fetchNewDateOrders() {
            console.log("fetchNewDateOrders called");
            const store = useDefaultStore();
            const { supabaseFetch } = useSupabase();
            const { orchestrateOrderFetch } = useData();

            this.cellsInitialized = false;
            console.log(
                "[DEBUG] fetchNewDateOrders: Clearing supabaseData for date switch. Was:",
                this.supabaseData?.map((p) => ({
                    id: p.id,
                    date: p.date,
                    done: p.done,
                })),
            );
            this.supabaseData = null;

            await Promise.all([
                orchestrateOrderFetch({
                    getDates: () => [this.date],
                    getFetchId: () => this.fetchId,
                    setFetchId: (id: number) => (this.fetchId = id),
                    setProcessing: (isProcessing: boolean) =>
                        (store.processing = isProcessing),
                    setLoading: (isLoading: boolean) =>
                        (store.loading = isLoading),
                }),
                supabaseFetch(),
            ]);

            this.initCells();

            this.checkForStammkunden();
        },

        async fetchNewWeekOrders() {
            console.log("fetchNewWeekOrders called");
            const store = useDefaultStore();
            const { getWeekDates } = useUtil();
            const { orchestrateOrderFetch } = useData();

            // reset days
            this.days = [];
            const weekDates = getWeekDates(this.week);
            let iterDate = new Date(weekDates.startDate);
            do {
                this.days.push(iterDate.toLocaleDateString("sv"));
                iterDate = new Date(iterDate.setDate(iterDate.getDate() + 1));
            } while (iterDate.toLocaleDateString("sv") != weekDates.endDate);
            this.days.push(weekDates.endDate);

            await orchestrateOrderFetch({
                getDates: () => this.days,
                getFetchId: () => this.fetchId,
                setFetchId: (id: number) => (this.fetchId = id),
                setProcessing: (isProcessing: boolean) =>
                    (store.processing = isProcessing),
                setLoading: (isLoading: boolean) => (store.loading = isLoading),
            });

            // this.checkForStammkunden(); // don't fetch for weekview
        },

        async fetchNewMonthOrders() {
            console.log("fetchNewMonthOrders called");
            const store = useDefaultStore();
            const { getISOWeek, getWeekDates } = useUtil();
            const { orchestrateOrderFetch } = useData();

            // reset days
            this.days = [];
            this.kws = [];
            this.kwDays = {};

            const [year, month] = this.month.split("-").map(Number);
            const date = new Date(year, month - 1, 1);
            const weeks = new Set();

            while (date.getMonth() === month - 1) {
                const week = getISOWeek(date);
                weeks.add(
                    `${(date as any).getWeekYear()}-${String(week).padStart(2, "0")}`,
                );
                date.setDate(date.getDate() + 1);
            }

            this.kws = Array.from(weeks);
            for (const kw of this.kws) {
                this.kwDays[kw] = [];
                const dates = getWeekDates(kw);
                let iterDate = new Date(dates.startDate);
                do {
                    const iterISO = iterDate.toLocaleDateString("sv");
                    this.kwDays[kw].push(iterISO);
                    this.days.push(iterISO);
                    iterDate = new Date(
                        iterDate.setDate(iterDate.getDate() + 1),
                    );
                } while (iterDate.toLocaleDateString("sv") != dates.endDate);
                this.days.push(dates.endDate);
                this.kwDays[kw].push(dates.endDate);
            }

            await orchestrateOrderFetch({
                getDates: () => this.days,
                getFetchId: () => this.fetchId,
                setFetchId: (id: number) => (this.fetchId = id),
                setProcessing: (isProcessing: boolean) =>
                    (store.processing = isProcessing),
                setLoading: (isLoading: boolean) => (store.loading = isLoading),
            });
        },

        // cells
        initCells() {
            console.log("initCells called");
            const store = useDefaultStore();
            if (this.page != "day") {
                store.loading = false;
                console.log("...but exited early");
                return;
            }

            // reset cells
            const cells = {};

            // orders of the day - per slot
            const ordersPerSlot = store.orderData?.[store.curShop.url][
                this.date
            ]?.reduce((acc, order) => {
                const { fsSlot } = order;
                if (!acc[fsSlot]) {
                    acc[fsSlot] = [];
                }
                acc[fsSlot].push(order);
                return acc;
            }, {});

            for (const slot in ordersPerSlot) {
                cells[slot] = {};
                const slotOrders = ordersPerSlot[slot];

                let slotProductNames = [];
                slotProductNames = slotOrders.flatMap((o) =>
                    o.menus.map((m) => m.name),
                );
                slotProductNames = [...new Set(slotProductNames)];

                for (const name of slotProductNames) {
                    const packedOrderNumbers = slotOrders
                        .filter(
                            (o) =>
                                o.menus.map((m) => m.name).includes(name) &&
                                o.packed,
                        )
                        .map((o) => o.orderNumber);

                    // Cell properties:
                    // - User interaction state: clickedDailyIds (unified for both modes)
                    // - Order completion state: packed
                    // - Identifiers: menu, slot
                    // Note: Preparation state (preparing, prepared, prepWorkerId) is now
                    // derived from supabaseData via store getters
                    cells[slot][name] = {
                        menu: name,
                        slot,
                        clickedDailyIds: [], // Unified click tracking for both modes
                        packed: [...packedOrderNumbers],
                    };
                }
            }

            // console.log("done initing cells...");
            this.cells = cells;
            this.cellsInitialized = true;
            store.loading = false; // change loading state of site to false to allow interaction as soon as cells are done
        },

        // workers
        async initWorkers() {
            console.log("initWorkers called");
            const store = useDefaultStore();
            const fsStore = useFunctionsheetStore();
            const url =
                "https://" +
                store.curShop.url +
                "/wp-json/refueat/v1/staff?capability=view_kitchen";
            const response = await store.fetchAllPages(url);

            // First pass: collect all workers with basic info
            const workersData = [];
            for (const worker of response) {
                workersData.push({
                    id: worker.username,
                    firstName:
                        worker.first_name || worker.username || worker.name,
                    lastName: worker.last_name || "",
                });
            }

            // Count occurrences of each first name
            const firstNameCounts = {};
            workersData.forEach((worker) => {
                const firstName = worker.firstName;
                firstNameCounts[firstName] =
                    (firstNameCounts[firstName] || 0) + 1;
            });

            // Second pass: create display names with last name initials when needed
            const workers = [];
            const usedNames = new Set();

            for (const workerData of workersData) {
                let displayName = workerData.firstName;

                // If there are multiple workers with same first name, add last name letters
                if (
                    firstNameCounts[workerData.firstName] > 1 &&
                    workerData.lastName
                ) {
                    let lastNameLetters = 1;
                    let candidateName;

                    // Keep adding letters until we get a unique name
                    do {
                        const lastNamePart = workerData.lastName.substring(
                            0,
                            lastNameLetters,
                        );
                        candidateName = `${workerData.firstName} ${lastNamePart}`;
                        lastNameLetters++;
                    } while (
                        usedNames.has(candidateName) &&
                        lastNameLetters <= workerData.lastName.length
                    );

                    displayName = candidateName;
                }

                // Handle edge case where even with full last name, name might not be unique
                let finalName = displayName;
                let counter = 1;
                while (usedNames.has(finalName)) {
                    finalName = `${displayName} (${counter})`;
                    counter++;
                }

                usedNames.add(finalName);

                workers.push({
                    id: workerData.id,
                    name: finalName,
                });
            }

            this.workers = workers;

            // get self information from jwt token - select if in workers list!
            const userData = store.parseJwt(store.auth.jwts[store.curShop.url]);
            if (userData) {
                const me = userData.data.user;
                fsStore.selectedWorkerId = me.username;
            }
        },

        async checkForCancellation() {
            const store = useDefaultStore();
            const shop = store.curShop;
            if (!store.rawOrderData || !Array.isArray(store.rawOrderData))
                return false;

            console.log("checking for cancellation");

            const apiOrderIds = new Set(store.rawOrderData.map((o) => o.id));
            const relevantDates = this.page === "day" ? [this.date] : this.days;

            const dbOrders = await db.orders
                .where("date")
                .anyOf(relevantDates)
                .and((order) => order.shopUrl === shop.url)
                .toArray();

            const cancelledOrders = dbOrders.filter(
                (dbOrder) => !apiOrderIds.has(dbOrder.id),
            );

            if (cancelledOrders.length > 0) {
                const cancelledOrderPrimaryKeys = cancelledOrders.map((o) => [
                    o.id,
                    o.dailyId,
                ]);
                const cancelledOrderIds = [
                    ...new Set(cancelledOrders.map((o) => o.id)),
                ];

                console.log(
                    `${cancelledOrderIds.length} orders were cancelled (or edited).`,
                );
                await db.orders.bulkDelete(
                    cancelledOrderPrimaryKeys as [number, string][],
                );

                // Reload data for affected dates into Pinia state
                for (const date of relevantDates) {
                    if (store.orderData?.[shop.url]?.[date]) {
                        store.orderData[shop.url][date] = store.orderData[
                            shop.url
                        ][date].filter(
                            (o) => !cancelledOrderIds.includes(o.id),
                        );
                    }
                }
                return true;
            }

            return false;
        },

        async checkForStammkunden() {
            console.log("called checkForStammkunden");

            const store = useDefaultStore();
            const urls = [];
            if (this.page == "day") {
                const ordersForDay =
                    store.orderData?.[store.curShop.url]?.[this.date];
                if (ordersForDay) {
                    for (const order of ordersForDay) {
                        if (order.isStammkunde == null) {
                            const stammkunde_url =
                                "https://" +
                                store.curShop.url +
                                "/wp-json/refueat/v1/ordercount-by-id?order_id=" +
                                order.id;
                            urls.push([stammkunde_url, order]);
                        }
                    }
                }
            } else if (this.page == "week") {
                for (const day of this.days) {
                    const ordersForDay =
                        store.orderData?.[store.curShop.url]?.[day];
                    if (ordersForDay) {
                        for (const order of ordersForDay) {
                            if (order.isStammkunde == null) {
                                const stammkunde_url =
                                    "https://" +
                                    store.curShop.url +
                                    "/wp-json/refueat/v1/ordercount-by-id?order_id=" +
                                    order.id;
                                urls.push([stammkunde_url, order]);
                            }
                        }
                    }
                }
            }
            const requests = [];
            for (const [stammkunde_url, order] of urls) {
                requests.push(
                    fetch(stammkunde_url, {
                        method: "GET",
                        headers: {
                            Authorization:
                                "Bearer " + store.auth.jwts[store.curShop.url],
                        },
                    })
                        .then((response) => {
                            return response.json();
                        })
                        .then(async (response) => {
                            if (response.length > 3) {
                                order.isStammkunde = true;
                            } else {
                                order.isStammkunde = false;
                            }
                            order.previousOrders = response;

                            await db.orders.put(
                                JSON.parse(JSON.stringify(order)),
                            );
                        }),
                );
            }
        },

        showStammkundeModal(target, order) {
            if (
                !!this.stammkundeModal.shown &&
                this.stammkundeModal.order.dailyId == order.dailyId
            ) {
                this.stammkundeModal.shown = false;
                return;
            }
            this.stammkundeModal.shown = true;
            this.stammkundeModal.order = order;

            this.stammkundeModal.top = target.offsetTop + 74;
            this.stammkundeModal.left =
                target.offsetLeft + target.offsetWidth + 22;
        },

        wcRealtimeInit() {
            console.log("[FunctionsheetStore] wcRealtimeInit called");
            if (this.wcInterval) {
                console.log(
                    "[FunctionsheetStore] wcRealtimeInit already active, skipping",
                );
                return;
            }

            // Clear any existing interval
            if (this.wcInterval) {
                clearInterval(this.wcInterval);
                this.wcInterval = null;
            }

            let realtimeFailed = false;
            let retryCount = 0;
            const maxRetries = 3;

            this.wcInterval = setInterval(
                async () => {
                    console.log("[FunctionsheetStore] Refreshing current day");
                    const fsStore = useFunctionsheetStore();
                    const store = useDefaultStore();

                    try {
                        // Check if realtime is working
                        if (!realtimeFailed) {
                            // Simple check - if supabase client exists and has channels
                            const isRealtimeHealthy =
                                window.supabase &&
                                window.supabase.getChannels().length > 0;

                            if (!isRealtimeHealthy) {
                                console.warn(
                                    "[FunctionsheetStore] Realtime connection unhealthy, increasing polling frequency",
                                );
                                realtimeFailed = true;
                                retryCount++;

                                // Increase polling frequency to 1 minute when realtime fails
                                // But only up to maxRetries times
                                if (retryCount <= maxRetries) {
                                    clearInterval(this.wcInterval);
                                    this.wcInterval = setInterval(
                                        arguments.callee,
                                        60 * 1000,
                                    );
                                    return;
                                } else {
                                    console.error(
                                        "[FunctionsheetStore] Max retries reached, reverting to 10-minute polling",
                                    );
                                    realtimeFailed = false;
                                    retryCount = 0;
                                    clearInterval(this.wcInterval);
                                    this.wcInterval = setInterval(
                                        arguments.callee,
                                        60 * 1000 * 10,
                                    );
                                    return;
                                }
                            }
                        }

                        // Reset realtime status if we're here
                        if (realtimeFailed) {
                            console.log(
                                "[FunctionsheetStore] Realtime connection restored",
                            );
                            realtimeFailed = false;
                            retryCount = 0;

                            // Reset to normal 10-minute polling
                            clearInterval(this.wcInterval);
                            this.wcInterval = setInterval(
                                arguments.callee,
                                60 * 1000 * 10,
                            );
                        }

                        await store.fetchOrders();
                        await store.processOrderData();
                        const ordersCancelled =
                            await this.checkForCancellation();

                        if (this.page === "day") {
                            const ordersForDay = await db.orders
                                .where({
                                    shopUrl: store.curShop.url,
                                    date: this.date,
                                })
                                .toArray();
                            store.orderData[store.curShop.url][this.date] =
                                ordersForDay;
                            if (
                                fsStore.updatedOrderDataProcessed ||
                                ordersCancelled
                            ) {
                                // notificationSound.play().catch(() => {
                                //     console.warn(
                                //         "[FunctionsheetStore] Notification sound playback was prevented by the browser.",
                                //     );
                                // });
                                this.initCells();
                            }
                        } else if (this.page === "week") {
                            const ordersForWeek = await db.orders
                                .where("date")
                                .anyOf(this.days)
                                .and(
                                    (order) =>
                                        order.shopUrl === store.curShop.url,
                                )
                                .toArray();
                            for (const day of this.days) {
                                store.orderData[store.curShop.url][day] = [];
                            }
                            for (const order of ordersForWeek) {
                                store.orderData[store.curShop.url][
                                    order.date
                                ].push(order);
                            }
                            if (
                                fsStore.updatedOrderDataProcessed ||
                                ordersCancelled
                            ) {
                                // notificationSound.play().catch(() => {
                                //     console.warn(
                                //         "[FunctionsheetStore] Notification sound playback was prevented by the browser.",
                                //     );
                                // });
                            }
                        }
                        fsStore.updatedOrderDataProcessed = false;
                    } catch (error) {
                        console.error(
                            "[FunctionsheetStore] Error in wcRealtimeInit:",
                            error,
                        );
                        realtimeFailed = true;
                        retryCount++;
                    }
                },
                60 * 1000 * 10,
            ); // 10 minutes when realtime is working
        },

        // Initialize the improved realtime system
        initRealtimeSystem() {
            if (typeof window === "undefined") return;

            const { supabaseRealtimeInitProcesses, supabaseFetch } =
                useSupabase();
            const store = useDefaultStore();

            console.log(
                "[DEBUG] initRealtimeSystem called for date:",
                this.date,
            );

            // Clean up any existing realtime subscriptions
            this.cleanupRealtimeSubscriptions();

            // Set up the realtime subscription with improved error handling
            const cleanupRealtime = supabaseRealtimeInitProcesses((payload) => {
                console.log("[Realtime] Received process update:", payload);
                this.handleRealtimeProcessUpdate(payload);
            });

            // Store cleanup function for later use
            if (!window.realtimeCleanupFunctions) {
                window.realtimeCleanupFunctions = [];
            }
            window.realtimeCleanupFunctions.push(cleanupRealtime);

            // Set up connection monitoring
            this.setupConnectionMonitoring();

            // Process any pending updates that were stored when offline
            this.processPendingUpdates();
        },

        // Clean up existing realtime subscriptions
        cleanupRealtimeSubscriptions() {
            if (typeof window === "undefined") return;

            console.log("[DEBUG] Cleaning up existing realtime subscriptions");

            // Execute all cleanup functions
            if (window.realtimeCleanupFunctions) {
                window.realtimeCleanupFunctions.forEach((cleanup) => {
                    try {
                        cleanup();
                    } catch (error) {
                        console.error(
                            "[DEBUG] Error cleaning up realtime subscription:",
                            error,
                        );
                    }
                });
                window.realtimeCleanupFunctions = [];
            }
        },

        // Handle realtime process updates with improved logic
        handleRealtimeProcessUpdate(payload) {
            const store = useDefaultStore();

            // Handle DELETE events
            if (payload.eventType === "DELETE") {
                const oldProcess = payload.old;
                if (!oldProcess) return;

                console.log("[DEBUG] Realtime DELETE event:", {
                    processId: oldProcess.id,
                    processDate: oldProcess.date,
                    currentDate: this.date,
                });

                // Remove from supabaseData
                if (this.supabaseData) {
                    this.supabaseData = this.supabaseData.filter(
                        (p: any) => p.id !== oldProcess.id
                    );
                    console.log(`[DEBUG] Removed process ${oldProcess.id} from supabaseData`);
                }
                return;
            }

            // Handle UPDATE and INSERT events
            if (
                payload.eventType === "UPDATE" ||
                payload.eventType === "INSERT"
            ) {
                const newProcess = payload.new;

                // DEBUG: Log date filtering details
                console.log("[DEBUG] Realtime update date check:", {
                    processDate: newProcess.date,
                    currentDate: this.date,
                    processLocation: newProcess.location,
                    currentLocation: store.curShop.name,
                    dateMatch: newProcess.date === this.date,
                    locationMatch: newProcess.location === store.curShop.name,
                    eventType: payload.eventType,
                    processId: newProcess.id,
                });

                // Skip if this process is for a different date or location
                if (
                    newProcess.date !== this.date ||
                    newProcess.location !== store.curShop.name
                ) {
                    console.log(
                        "[DEBUG] Skipping realtime update for different date/location:",
                        {
                            reason:
                                newProcess.date !== this.date
                                    ? "date mismatch"
                                    : "location mismatch",
                            processDate: newProcess.date,
                            currentDate: this.date,
                            processLocation: newProcess.location,
                            currentLocation: store.curShop.name,
                        },
                    );
                    return;
                }

                // Additional check: only process updates for the current page type
                if (this.page !== "day") {
                    console.log(
                        "[DEBUG] Skipping realtime update - not on day view",
                    );
                    return;
                }

                // Update supabaseData (single source of truth)
                if (this.supabaseData) {
                    const existingIndex = this.supabaseData.findIndex(
                        (p: any) => p.id === newProcess.id,
                    );
                    if (existingIndex >= 0) {
                        // Update existing process - use splice for better reactivity
                        this.supabaseData.splice(existingIndex, 1, newProcess);
                    } else {
                        // Add new process
                        this.supabaseData.push(newProcess);
                    }
                }

                // Clear clicked state for affected cells
                this.updateCellsFromProcess(newProcess);

                // Double-check that cells are correctly updated for done processes
                if (newProcess.done && !newProcess.aborted) {
                    setTimeout(() => {
                        this.verifyCellStatesForProcess(newProcess);
                    }, 100);
                }
            }
        },

        // Update cells based on process data - only clears clicked state (user interaction)
        // Preparation state is now derived from supabaseData via store getters
        updateCellsFromProcess(process) {
            const store = useDefaultStore();
            console.log("[DEBUG] updateCellsFromProcess called:", {
                processId: process.id,
                processDone: process.done,
                processAborted: process.aborted,
            });

            const dailyIdProducts = process.daily_id_products;
            if (!dailyIdProducts || Object.keys(dailyIdProducts).length === 0) {
                return;
            }

            // Only clear clicked state for affected cells (user interaction state)
            // Preparation state is derived from supabaseData
            for (const [dailyId, products] of Object.entries(dailyIdProducts)) {
                const order = store.orderData?.[store.curShop.url]?.[this.date]
                    ?.find((o) => o.dailyId === dailyId);
                if (!order) continue;

                for (const productName of Object.keys(products as Record<string, unknown>)) {
                    const theCell = this.cells?.[order.fsSlot]?.[productName];
                    if (theCell) {
                        // Clear clicked state for this dailyId
                        theCell.clickedDailyIds = (theCell.clickedDailyIds || []).filter(
                            (id) => id !== dailyId
                        );
                    }
                }
            }
        },

        // Set up connection monitoring with visual indicators
        setupConnectionMonitoring() {
            if (typeof window === "undefined") return;

            console.log(
                "[FunctionsheetStore] Setting up connection monitoring",
            );

            // Import and use the connection monitoring from useSupabase
            const { startConnectionMonitoring } = useSupabase();

            // Start connection monitoring
            const intervalId = startConnectionMonitoring();

            // Store interval ID for cleanup
            if (!(window as any).connectionMonitoringIntervals) {
                (window as any).connectionMonitoringIntervals = [];
            }
            (window as any).connectionMonitoringIntervals.push(intervalId);
        },

        // Verify that process is in supabaseData (no longer updates cell state)
        // UI now derives all preparation state from supabaseData via store getters
        verifyCellStatesForProcess(process) {
            // Verification now just checks that the process is in supabaseData
            if (!this.supabaseData) return;

            const exists = this.supabaseData.some((p: any) => p.id === process.id);
            if (!exists) {
                console.warn(
                    "[DEBUG] Process not found in supabaseData after realtime update:",
                    process.id,
                );
            }
        },

        // Attempt to reconnect to Supabase
        async attemptReconnection() {
            const { initSupabase, supabaseRealtimeInitProcesses } =
                useSupabase();

            try {
                console.log("[Reconnection] Attempting to reconnect...");
                await initSupabase();

                // Reinitialize realtime subscriptions
                const cleanupRealtime = supabaseRealtimeInitProcesses(
                    (payload) => {
                        this.handleRealtimeProcessUpdate(payload);
                    },
                );

                // Replace old cleanup function with new one
                const index = window.realtimeCleanupFunctions.findIndex((fn) =>
                    fn.toString().includes("db-changes-processes"),
                );
                if (index !== -1) {
                    window.realtimeCleanupFunctions[index] = cleanupRealtime;
                }

                console.log("[Reconnection] Reconnection successful");
            } catch (error) {
                console.error("[Reconnection] Failed to reconnect:", error);
            }
        },

        // Process any pending updates that were stored when offline
        async processPendingUpdates() {
            if (
                !window.pendingProcessUpdates ||
                window.pendingProcessUpdates.length === 0
            ) {
                return;
            }

            console.log(
                `[Pending Updates] Processing ${window.pendingProcessUpdates.length} pending updates`,
            );

            const updatesToProcess = [...window.pendingProcessUpdates];
            window.pendingProcessUpdates = [];

            for (const update of updatesToProcess) {
                try {
                    const { error } = await window.supabase
                        .from("processes_new")
                        .upsert(update);

                    if (error) {
                        console.error(
                            "[Pending Updates] Failed to process update:",
                            error,
                        );
                        // Add back to pending queue
                        window.pendingProcessUpdates.push(update);
                    }
                } catch (error) {
                    console.error("[Pending Updates] Unexpected error:", error);
                    // Add back to pending queue
                    window.pendingProcessUpdates.push(update);
                }
            }
        },
    },
    persist: {
        pick: ["groupByFinishTime"],
    },
});

// prototype expansion
// maybe TODO: find better place for this
(Date.prototype as any).getWeekYear = function () {
    const date = new Date(this.getTime());
    date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
    return date.getFullYear();
};

const notificationSound = new Audio("/audios/notification.wav");
notificationSound.preload = "auto";
